import { render, staticRenderFns } from "./OrderServiceGeneralQuotationInfo.vue?vue&type=template&id=aac5c996&scoped=true&"
import script from "./OrderServiceGeneralQuotationInfo.vue?vue&type=script&lang=js&"
export * from "./OrderServiceGeneralQuotationInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderServiceGeneralQuotationInfo.vue?vue&type=style&index=0&id=aac5c996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac5c996",
  null
  
)

export default component.exports